import PriceModuleProductLinkEnum from '../enums/PriceModuleProductLinkEnum.js';
export default class PriceModuleUtility {
    /**
     * Whether the Price Module should render an interactive product name or not.
     *
     * @param linkType The link type.
     * @param disableLinks Whether links are disabled or not.
     */
    static showInteractiveProductName(linkType, disableLinks) {
        if (linkType === PriceModuleProductLinkEnum.disabled) {
            return false;
        }
        if (linkType === PriceModuleProductLinkEnum.productInformationPage) {
            return !disableLinks;
        }
        return true;
    }
}
//# sourceMappingURL=PriceModuleUtility.js.map